import type { NodeAutoCompleteRuleRunNodeLogVO } from '../api/types/nodeAutoCompleteRule';
import { pickSnakeCamel as pick } from './formatServerDateTime';

/** 构建项目排期详情页 URL（含 basename，可新窗口打开） */
export function buildProjectScheduleDetailUrl(projectId: number, scheduleId?: number | null): string {
  const base = (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL || '/';
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;
  const path = `${normalizedBase}/schedule/${projectId}`;
  const query = scheduleId && scheduleId > 0 ? `?scheduleId=${scheduleId}` : '';
  return `${window.location.origin}${path}${query}`;
}

/** 从节点日志行解析项目/版本 ID（优先 DB 字段，其次 Jint 入参） */
export function resolveRunNodeLogNavIds(row: NodeAutoCompleteRuleRunNodeLogVO): {
  projectId?: number;
  scheduleId?: number;
} {
  const projectId = pick(row.project_id, row.projectId);
  const scheduleId = pick(row.schedule_id, row.scheduleId);
  if (projectId && projectId > 0) {
    return { projectId, scheduleId: scheduleId && scheduleId > 0 ? scheduleId : undefined };
  }

  const inputJson = pick(row.prepare_input_json, row.prepareInputJson);
  if (!inputJson) return {};

  try {
    const parsed = JSON.parse(inputJson) as Record<string, unknown>;
    const nodeContext = (parsed.nodeContext ?? parsed.node_context) as Record<string, unknown> | undefined;
    if (!nodeContext) return {};

    const ctxProjectId = Number(nodeContext.projectId ?? nodeContext.project_id);
    const ctxScheduleId = Number(nodeContext.scheduleId ?? nodeContext.schedule_id);
    if (!Number.isFinite(ctxProjectId) || ctxProjectId <= 0) return {};

    return {
      projectId: ctxProjectId,
      scheduleId: Number.isFinite(ctxScheduleId) && ctxScheduleId > 0 ? ctxScheduleId : undefined,
    };
  } catch {
    return {};
  }
}

export function openProjectScheduleDetail(projectId: number, scheduleId?: number | null): void {
  const url = buildProjectScheduleDetailUrl(projectId, scheduleId);
  window.open(url, '_blank', 'noopener,noreferrer');
}
